var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section shop"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"title"},[_vm._v("ONLINE SHOP")]),_c('div',{staticClass:"button",on:{"click":_vm.goUrl}},[_vm._v("SET OUT")])])])}
var staticRenderFns = []

export { render, staticRenderFns }